module.exports = __webpack_public_path__ + "src/assets/img/engine_five_color.66ce1be7.svg";